import moment from 'moment';
import { getMomentDateStringFromRangeArray } from '@/utils/dateUtil';
import { PPA_SOURCE_API } from '@/api';
import config from './ppaSchedulesConfigs';

const state = {
  tableData: [],
  tableConfig: config.fields,
};

const actions = {
  async fetchPPASchedulesData({ commit }, parameters = {}) {
    const { startDate, endDate } = getMomentDateStringFromRangeArray(parameters.tradeDateRangeSelected);
    const params = {
      ppas: parameters.ppasSelected,
      startDate,
      endDate,
    };
    try {
      const { data: { data } } = await PPA_SOURCE_API.post('/schedules/get', params);
      if (Array.isArray(data)) {
        data.forEach((x) => {
          x.tradingDate = moment(x.tradingDate).utc().format('MM/DD/YYYY');
        });
        commit('setTableData', data);
      }
    } catch (err) {
      console.error(err);
      this.$notify('Failed to load Schedules Data', 'error');
    }
  },
};

const mutations = {
  setTableData(state, value) {
    state.tableData = Object.freeze(value);
  },
  reset(state) {
    state.tableData = [];
  },
  setTableConfig(state, value) {
    state.tableConfig = value;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};